export class ConnectionEventHandlers {
  private socket: any;
  private wrapper: any;
  private offlineHandler: (() => void) | null = null;

  constructor(socket: any, wrapper?: any) {
    this.socket = socket;
    this.wrapper = wrapper;
  }

  /**
   * Initialize all event handlers
   */
  initialize(): void {
    this.setupNetworkHandlers();
  }

  /**
   * Clean up all event handlers
   */
  cleanup(): void {
    if (this.offlineHandler) {
      window.removeEventListener('offline', this.offlineHandler);
    }
  }

  /**
   * Set up network offline event handler
   */
  private setupNetworkHandlers(): void {
    this.offlineHandler = () => {
      console.log('Network offline event detected');

      if (this.socket && this.socket.connectionManager) {
        // Always update state to offline when network goes down
        // This provides immediate UI feedback to the user
        console.log('Updating connectionState to offline due to network loss');
        this.socket.connectionManager.connectionState = 'offline';
        this.socket.connectionManager.emit('connectionStateChanged', 'offline');
      }
    };

    window.addEventListener('offline', this.offlineHandler);
    console.log('Network offline handler registered');
  }
}
